var map = {
	"./featured_img.png": 53,
	"./featured_img_two copy.png": 162,
	"./featured_img_two.png": 55,
	"./flag.png": 163,
	"./footer.png": 164,
	"./icon1.png": 54,
	"./icon2.png": 27,
	"./icon3.png": 94,
	"./icon4.png": 165,
	"./icon5.png": 166,
	"./icon6.png": 167,
	"./icon7.png": 168,
	"./icon8.png": 169,
	"./icon_shape.png": 21,
	"./icon_shape_two.png": 170,
	"./kitchen_display.gif": 171,
	"./kitchen_display.png": 86,
	"./logo1.png": 95,
	"./logo2.png": 96,
	"./logo3.png": 97,
	"./logo4.png": 56,
	"./logo5.png": 98,
	"./logo6.png": 99,
	"./logo7.png": 100,
	"./logo8.png": 101,
	"./logo_gradient.png": 83,
	"./mac.png": 51,
	"./map.png": 172,
	"./reports.png": 85,
	"./shape-footer.png": 173,
	"./shape.png": 52,
	"./shape_two.png": 174,
	"./snapserve.png": 175,
	"./snapserve.svg": 84,
	"./testimonial_img.png": 87,
	"./testimonial_img2.png": 176,
	"./triangle_bottom.png": 177,
	"./triangle_top.png": 178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 391;